var React = require('react');

function Expo2023arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#1d1d1b;}")),React.createElement("polygon",{"points":"8.38 3.39 4.9 .2 3.7 .2 .21 3.39 1.15 4.42 3.01 2.72 3.01 2.71 3.43 2.33 3.62 2.16 3.67 7.26 4.13 8 5.06 7.99 5.06 6.77 5.01 2.19 7.45 4.42 8.38 3.39","key":1})]);
}

Expo2023arrow.defaultProps = {"id":"Ebene_1","viewBox":"0 0 8.59 8.21"};

module.exports = Expo2023arrow;

Expo2023arrow.default = Expo2023arrow;
